/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getProjectRestoreUrl = (projectId: number | string): string =>
	`/rest/api/2/project/${projectId}/restore`;
